import { AppId, BackofficeProvider } from '@revolut-internal/backoffice-provider'

import { Auth } from '../common/auth/auth'
import { MENU_ITEMS } from '../modules/Monitoring/consts/navigation'
import { Route } from '../modules/Monitoring/consts/routes'
import { FCWithChildren } from '../modules/Monitoring/types'

export const RootProvider: FCWithChildren = ({ children }) => {
  return (
    <BackofficeProvider
      appId={AppId.RealTimeMonitoring}
      menuItems={MENU_ITEMS}
      defaultRoute={Route.Ticket}
      auth={Auth}
    >
      {children}
    </BackofficeProvider>
  )
}
